import {
  // drawerWidth,
  // transition,
  boxShadow,
  // defaultFont,
  // primaryColor,
  // primaryBoxShadow,
  // infoColor,
  // successColor,
  // warningColor,
  // dangerColor,
  // whiteColor,
  // grayColor,
  blackColor
  // ,
  // hexToRgb
} from "assets/jss/material-kit-pro-react.jsx";

import image from 'images/sidebar-4.jpg';

export default theme => ({
  root: {
    color: theme.palette.common.white,
    backgroundColor: '#18202c',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    ...boxShadow,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    backgroundImage: "url(" + image + ")",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    "&:after": {
      position: "absolute",
      zIndex: "3",
      width: "100%",
      height: "100%",
      display: "block",
      background: blackColor,
      opacity: ".8"
    }
  },
  logoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '63px',
    flexShrink: 0
  },

  background: {
    position: "absolute",
    zIndex: "1",
    height: "100%",
    width: "100%",
    display: "block",
    top: "0",
    left: "0",

  },

  logoLink: {
    fontSize: 0
  },
  logoImage: {
    cursor: 'pointer'
  },
  logoDivider: {
    color: 'rgba(255, 255, 255, 0.7)',
    marginBottom: theme.spacing.unit * 2
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: '100px',
    height: '100px'
  },
  nameText: {
    color: 'rgba(255, 255, 255, 0.7)',
    marginTop: theme.spacing.unit * 2
  },
  bioText: {
    color: 'rgba(255, 255, 255, 0.7)'
  },
  profileDivider: {
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    marginBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2
  },
  listSubheader: {
    color: 'rgba(255, 255, 255, 0.7)'
  },
  listItem: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: "300",
    lineHeight: "1.5em",
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(92,113,145,0.7)',
      borderLeft: `4px solid rgba(92,113,145,1)`,
      borderRadius: '4px',
      '& $listItemIcon': {
        color: 'rgba(255, 255, 255, 0.7)',
        marginLeft: '-4px'
      }
    },
    '& + &': {
      marginTop: theme.spacing.unit
    }
  },
  activeListItem: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    borderRadius: '4px',
    backgroundColor: theme.palette.primary.light,
    '& $listItemText': {
      color: 'rgba(255, 255, 255, 0.7)'
    },
    '& $listItemIcon': {
      color: 'rgba(255, 255, 255, 0.7)',
      marginLeft: '-4px'
    }
  },
  listItemIcon: {
    color: 'rgba(255, 255, 255, 0.7)',
    marginRight: 0
  },
  listItemText: {
    fontWeight: 500,
    color: 'rgba(255, 255, 255, 0.7)'
  },
  listDivider: {
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    marginBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2
  }
});
